module.exports = __webpack_public_path__ + "img/ysgj_045@2x.fe8c5443.png";